export default __webpack_public_path__ + "static/media/coin_jpy.588a8a37.svg";